import { Observable } from "rxjs";

import { CustomersRepository } from "lib/repositories/index";
import st from "lib/utils/index";
import { pushCompanyRoute } from "modules/app/actions";
import { createResourceInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "customers/ShowCustomerView/INITIALIZE_VIEW";
export const LOAD_CUSTOMER = "customers/ShowCustomerView/LOAD_CUSTOMER";
export const FETCH_CUSTOMER = "customers/ShowCustomerView/FETCH_CUSTOMER";
export const FETCH_CUSTOMER_START = "customers/ShowCustomerView/FETCH_CUSTOMER_START";
export const FETCH_CUSTOMER_SUCCESS = "customers/ShowCustomerView/FETCH_CUSTOMER_SUCCESS";
export const FETCH_CUSTOMER_FAILURE = "customers/ShowCustomerView/FETCH_CUSTOMER_FAILURE";

export const stateSelector = (state) => state.customers.ShowCustomerView;

const customerResource = createResourceInstance({
  LOAD: LOAD_CUSTOMER,
  FETCH: FETCH_CUSTOMER,
  FETCH_START: FETCH_CUSTOMER_START,
  FETCH_SUCCESS: FETCH_CUSTOMER_SUCCESS,
  FETCH_FAILURE: FETCH_CUSTOMER_FAILURE,
  stateSelector,
  stateKey: "customer",
  getModel: ({ customerId }) => {
    return CustomersRepository.find(customerId);
  },
});

const initialState = {
  customer: customerResource.initialState,
  customerId: null,
};

const reducers = {
  ...customerResource.reducersMap,

  [INITIALIZE_VIEW]: (state, { customerId }) => ({
    ...initialState,
    customerId,
  }),
};

const epics = [...customerResource.epics, (actions$) => actions$.ofType(INITIALIZE_VIEW).mapTo(fetchCustomer())];

export const { fetch: fetchCustomer, load: loadCustomer } = customerResource.actions;

export function initializeView(customerId) {
  return { type: INITIALIZE_VIEW, customerId };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/customers/ShowCustomerView/index.js